import { MassTortOverviewView } from "@/components/features/mass-torts/MassTortOverviewView";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { massTortSearchId } = Route.useParams();

  return <MassTortOverviewView massTortSearchId={massTortSearchId} />;
}
